<template>
  <div class="mut" role="group" :aria-label="`Medir la cantidad de ${itemName} en`">
    <button
      v-for="option in options"
      :key="option.mode"
      type="button"
      class="mut-option"
      :class="{ 'mut-option--selected': mode === option.mode }"
      :aria-pressed="String(mode === option.mode)"
      @click="$emit('change', option.mode)"
    >{{ option.label }}</button>
  </div>
</template>

<script>
import { BOXES_MODE, UNITS_MODE } from './materialsOrderBoxes';

const OPTIONS = [
  { mode: UNITS_MODE, label: 'Unidades' },
  { mode: BOXES_MODE, label: 'Cajas' },
];

export default {
  name: 'MaterialsOrderUnitToggle',
  props: {
    mode: { type: String, required: true },
    itemName: { type: String, required: true },
  },
  computed: {
    options() {
      return OPTIONS;
    },
  },
};
</script>

<style scoped>
.mut {
  display: inline-flex;
  border: 1.5px solid #d3ecde;
  border-radius: 12px;
  overflow: hidden;
}
.mut-option {
  border: none;
  background: #fff;
  color: #01662E;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  font-family: inherit;
}
.mut-option:not(.mut-option--selected):hover { background: #f1f8f4; }
.mut-option:focus-visible {
  outline: 2px solid #01662E;
  outline-offset: -2px;
}
.mut-option--selected {
  background: #01662E;
  color: #fff;
}
</style>
